/**
 * Beta: only these users can see and use the ChatBot.
 * Add more emails as needed until the feature is live for everyone.
 */
export const ALLOWED_CHAT_BETA_EMAILS = [
  'granandakrishnan+2025@gmail.com','lspacekochi+2@gmail.com'
];

export function isAllowedChatUser(email) {
  if (!email || typeof email !== 'string') return false;
  return ALLOWED_CHAT_BETA_EMAILS.includes(email.trim().toLowerCase());
}
